import { useState } from "react";
import { useAuth } from "../firebase/auth.tsx";
import CreateHQModal from "./modals/createHQModal.tsx";
import CreateHospitalModal from "./modals/createHospitalModal.tsx";
import CreateAccountModal from "./modals/createAccountModal.tsx";
import CreateLicenseModal from "./modals/createLicenseModal.tsx";
import CreateTrainingPlanModal from "./modals/createTrainingPlanModal.tsx";
import { correctUserRoleName } from "./helpers/helpers.tsx";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const AdminMenu = ({
  updateHeadquarters,
  updateHeadsets,
  updateHospitals,
  updateUserList,
  updateLicenseList,
  updateTrainingPlanList,
  selector,
}) => {
  const { userId, userRole } = useAuth();
  const [showCreateHQModal, setShowCreateHQModal] = useState(false);
  const [showCreateHospitalModal, setShowCreateHospitalModal] = useState(false);
  const [showCreateAccountModal, setShowCreateAccountModal] = useState(false);
  const [showCreateLicenseModal, setShowCreateLicenseModal] = useState(false);
  const [showCreatePlanModal, setShowCreatePlanModal] = useState(false);

  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const handleCreateHQClick = async () => {
    setShowCreateHQModal(true);
  };

  const handleCreateHospitalClick = async () => {
    setShowCreateHospitalModal(true);
  };

  const handleCreateAccountClick = () => {
    setShowCreateAccountModal(true);
  };

  const handleCreateLicenseClick = () => {
    setShowCreateLicenseModal(true);
  };

  const handleCreatePlanClick = () => {
    setShowCreatePlanModal(true);
  };

  const handleCreateHQ = (newHeadquarter: any[]) => {
    updateHeadquarters(newHeadquarter);
    setShowCreateHQModal(false);
  };
  
  const handleCreateHospital = (newHospital: any[]) => {
    updateHospitals(newHospital); 
    setShowCreateHospitalModal(false);
  };

  const handleCreateAccount = (newAccount: any[]) => {
    updateUserList(newAccount);
  };

  const handleCreateLicense = (newLicense: any) => {
    if (updateLicenseList) updateLicenseList(newLicense);
    setShowCreateLicenseModal(false);
  };

  const handleCreatePlan = (newPlan: any) => {
    if (updateTrainingPlanList) updateTrainingPlanList(newPlan);
    setShowCreatePlanModal(false);
  };

  const renderCreateHQModal = () => {
    return (
      <div className={"adminContainer"}>
        <CreateHQModal
          setShowCreateHQModal={setShowCreateHQModal}
          handleCreateHQ={handleCreateHQ}
        />
      </div>
    );
  };

  const renderCreateHospitalModal = () => {
    return (
      <div className={"adminContainer"}>
        <CreateHospitalModal
          setShowCreateHospitalModal={setShowCreateHospitalModal}
          headquarterId={""}
          handleCreateHospital={handleCreateHospital}
        />
      </div>
    );
  };

  const renderCreateAccountModal = () => {
    return (
      <div className={"adminContainer"}>
        <CreateAccountModal
          setShowCreateAccountModal={setShowCreateAccountModal}
          headsetId={""}
          headquarterId={""}
          hospitalId={""}
          userRole={"guest"}
          adminView={true}
          handleCreateAccount={handleCreateAccount}
        />
      </div>
    );
  };

  const renderCreateLicenseModal = () => {
    return (
      <div className={"adminContainer"}>
        <CreateLicenseModal
          setShowCreateLicenseModal={setShowCreateLicenseModal}
          handleCreateLicense={handleCreateLicense}
          headquarterId={""} 
        />
      </div>
    );
  };

  const renderCreatePlanModal = () => {
    return (
      <div className={"adminContainer"}>
        <CreateTrainingPlanModal
          setShowCreatePlanModal={setShowCreatePlanModal}
          handleCreatePlan={handleCreatePlan}
          headquarterId={""}
        />
      </div>
    );
  };

  return (
    <>
      <div
        style={{
          backgroundColor: "#D4E5E2",
          borderRadius: "10px",
          marginTop: "86px",
          marginLeft: "50px",
          marginRight: "50px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: "70px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          {selector === "Headquarters" && (
            <img
              src="/images/Icon_HQ.png"
              alt="Logo"
              style={{
                width: "4vh",
                minWidth: "20px",
                marginLeft: "2vh",
              }}
            />
          )}
          {(selector === "Hospitals" || selector === "Headsets" || selector === "LicenseList" || selector === "TrainingPlanList") && (
            <img
              src="/images/Icon_Hospital.png"
              alt="Logo"
              style={{
                width: "4vh",
                minWidth: "20px",
                marginLeft: "2vh",
              }}
            />
          )}
          {selector === "Users" && (
            <img
              src="/images/Icon_User_Simple.png"
              alt="Logo"
              style={{
                width: "4vh",
                minWidth: "20px",
                marginLeft: "2vh",
              }}
            />
          )}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              marginLeft: "20px",
              color: "white",
              lineHeight: "1",
            }}
          >
            <div
              style={{
                textAlign: "left",
                paddingBottom: "8px",
                color: "#39a686",
                fontSize: "1.3em",
              }}
            >
              <strong>{
                selector === "Headquarters" ? t("Headquarters") : 
                selector === "Hospitals" ? t("Hospitals") : 
                selector === "Headsets" ? t("Headsets") : 
                selector === "Users" ? t("Users") : 
                selector === "LicenseList" ? t("License_List") :
                selector === "TrainingPlanList" ? t("Training_Plans") :
                selector
              }</strong>
            </div>
            <div
              style={{
                textAlign: "left",
                fontFamily: "VirtualLabQuickSandBold",
                color: "#212529",
                fontSize: "1.1em",
              }}
            >
              {t("Your_role")}:{" "}
              {
                <span style={{ fontFamily: "VirtualLabQuickSandMedium" }}>
                  {correctUserRoleName(userRole, t)}
                </span>
              }
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            marginRight: "20px",
          }}
        >
          {selector === "Headquarters" && (
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleCreateHQClick}
              style={{
                backgroundColor: "#39A686",
                borderColor: "#39A686",
                borderRadius: "10px",
                marginRight: "10px",
                fontSize: "1.2em",
              }}
            >
              {t("create_new_headquarter")}
            </button>
          )}
          {selector === "Hospitals" && (
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleCreateHospitalClick}
              style={{
                backgroundColor: "#39A686",
                borderColor: "#39A686",
                borderRadius: "10px",
                marginRight: "10px",
                fontSize: "1.2em",
              }}
            >
              {t("Create_new_hospital")}
            </button>
          )}
          
          {selector === "Users" && (
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleCreateAccountClick}
              style={{
                backgroundColor: "#39A686",
                borderColor: "#39A686",
                borderRadius: "10px",
                marginRight: "10px",
                fontSize: "1.2em",
              }}
            >
              {t("Create_new_User")}
            </button>
          )}

          {selector === "LicenseList" && (
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleCreateLicenseClick}
              style={{
                backgroundColor: "#39A686",
                borderColor: "#39A686",
                borderRadius: "10px",
                marginRight: "10px",
                fontSize: "1.2em",
              }}
            >
              {t("Add_new_license")}
            </button>
          )}

          {selector === "TrainingPlanList" && (
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleCreatePlanClick}
              style={{
                backgroundColor: "#39A686",
                borderColor: "#39A686",
                borderRadius: "10px",
                marginRight: "10px",
                fontSize: "1.2em",
              }}
            >
              {t("Add_new_training_plan")}
            </button>
          )}
        </div>
      </div>
      {(showCreateHQModal && renderCreateHQModal()) ||
        (showCreateHospitalModal && renderCreateHospitalModal()) ||
        (showCreateAccountModal && renderCreateAccountModal()) ||
        (showCreateLicenseModal && renderCreateLicenseModal()) ||
        (showCreatePlanModal && renderCreatePlanModal())}
    </>
  );
};

export default AdminMenu;